import React, { useEffect, useId } from "react";
import { useTranslation } from "react-i18next";
import Icon from "./Icon";

// Panneau par-dessus l'écran en cours (maquette : facture nominative, « Comment ça
// marche ? », confirmations). Sur mobile il monte du bas de l'écran ; en version
// web c'est une modale centrée de 480 px, avec une croix de fermeture si
// `showClose` (comme sur la maquette web pour 1k et 1m).
export default function BottomSheet({ open, onClose, title, showClose = false, children }) {
  const { t } = useTranslation();
  const titleId = useId();

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center font-montserrat text-qv-ink md:items-center md:p-10">
      <div className="absolute inset-0 bg-[rgba(25,25,25,.5)]" onClick={onClose} aria-hidden="true" />
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        className="relative w-full max-h-[90dvh] overflow-y-auto bg-white rounded-t-3xl px-6 pt-3 pb-7 md:max-w-[480px] md:rounded-2xl md:p-8 md:shadow-[0_20px_24px_-4px_rgba(10,13,18,.12)]"
      >
        <div className="w-10 h-1 rounded bg-qv-handle mx-auto mb-4 md:hidden" aria-hidden="true" />
        {showClose && onClose && (
          <button
            type="button"
            onClick={onClose}
            aria-label={t("common.close")}
            className="absolute right-5 top-5 hidden h-9 w-9 items-center justify-center rounded-full text-qv-muted hover:bg-qv-canvas md:flex"
          >
            <Icon name="close-circle-linear" size={22} />
          </button>
        )}
        {title && (
          <h2 id={titleId} className="text-xl leading-7 font-bold mb-1.5 md:mr-10 md:text-[22px] md:leading-[30px]">
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  );
}
